// The email credential exists only in memory, never in router params or storage.
let pendingLink = null

export const isPasswordRecoveryState = (name) => ['forgotPassword', 'recoverAccess'].includes(name)

export function capturePasswordRecoveryLink() {
  if (typeof window === 'undefined' || !['/forgot-password', '/recuperar-acceso'].includes(window.location.pathname.replace(/\/$/, ''))) return
  const fragment = new URLSearchParams(window.location.hash.slice(1))
  if (!fragment.has('k')) return
  pendingLink = fragment.get('k') || ''
  // Strip the credential before React, the router, or diagnostics can read it.
  window.history.replaceState({ ...window.history.state, passwordRecoveryStarted: true }, '', `${window.location.pathname}${window.location.search}`)
}

export function takePasswordRecoveryLink() {
  capturePasswordRecoveryLink()
  const link = pendingLink
  pendingLink = null
  return link
}

export function forgetPasswordRecoveryLink() {
  pendingLink = null
  if (typeof window !== 'undefined' && window.history.state?.passwordRecoveryStarted) {
    const { passwordRecoveryStarted, ...state } = window.history.state
    window.history.replaceState(state, '', `${window.location.pathname}${window.location.search}`)
  }
}
